module.exports = __webpack_public_path__ + "img/menu1.7709cb47.png";